/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DDTAttiviDTO
 */
export interface DDTAttiviDTO {
    /**
     * 
     * @type {string}
     * @memberof DDTAttiviDTO
     */
    numero?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DDTAttiviDTO
     */
    data?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DDTAttiviDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the DDTAttiviDTO interface.
 */
export function instanceOfDDTAttiviDTO(value: object): value is DDTAttiviDTO {
    return true;
}

export function DDTAttiviDTOFromJSON(json: any): DDTAttiviDTO {
    return DDTAttiviDTOFromJSONTyped(json, false);
}

export function DDTAttiviDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DDTAttiviDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'numero': json['numero'] == null ? undefined : json['numero'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function DDTAttiviDTOToJSON(json: any): DDTAttiviDTO {
    return DDTAttiviDTOToJSONTyped(json, false);
}

export function DDTAttiviDTOToJSONTyped(value?: DDTAttiviDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'numero': value['numero'],
        'data': value['data'] == null ? undefined : ((value['data'] as any).toISOString()),
        'descrizione': value['descrizione'],
    };
}

